import createIcon from '@/lib/create-icon'

const AlpineSkiingIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M38.33 8.625C38.33 10.2128 37.0435 11.5 35.4567 11.5C33.8697 11.5 32.5833 10.2128 32.5833 8.625C32.5833 7.03718 33.8697 5.75 35.4567 5.75C37.0435 5.75 38.33 7.03718 38.33 8.625Z'
      stroke='url(#paint0_linear_5304_2392)'
      strokeWidth='2.875'
      fill='none'
    />
    <path
      d='M38.33 8.625C38.33 10.2128 37.0435 11.5 35.4567 11.5C33.8697 11.5 32.5833 10.2128 32.5833 8.625C32.5833 7.03718 33.8697 5.75 35.4567 5.75C37.0435 5.75 38.33 7.03718 38.33 8.625Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      fill='none'
    />
    <path
      d='M38.33 8.625C38.33 10.2128 37.0435 11.5 35.4567 11.5C33.8697 11.5 32.5833 10.2128 32.5833 8.625C32.5833 7.03718 33.8697 5.75 35.4567 5.75C37.0435 5.75 38.33 7.03718 38.33 8.625Z'
      stroke='url(#paint1_radial_5304_2392)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      fill='none'
    />
    <path
      d='M23.9175 14.9869L25.9779 13.1326C27.024 12.191 28.598 12.1453 29.6972 13.0245L32.5833 15.3335M23.9175 14.9869L29.325 18.5918L32.5833 15.3335M23.9175 14.9869L11.5 6.7085M32.5833 15.3335L33.5417 21.403L40.25 25.8752M23.9583 23.9585L21.288 22.1783C19.9964 21.3171 19.6625 19.6399 20.3755 18.3755M23.9583 23.9585L28.4832 27.1906C29.5533 27.9549 29.5533 29.5454 28.4832 30.3098L23.9583 33.5418M23.9583 23.9585L25.875 22.0418'
      stroke='url(#paint2_linear_5304_2392)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M23.9175 14.9869L25.9779 13.1326C27.024 12.191 28.598 12.1453 29.6972 13.0245L32.5833 15.3335M23.9175 14.9869L29.325 18.5918L32.5833 15.3335M23.9175 14.9869L11.5 6.7085M32.5833 15.3335L33.5417 21.403L40.25 25.8752M23.9583 23.9585L21.288 22.1783C19.9964 21.3171 19.6625 19.6399 20.3755 18.3755M23.9583 23.9585L28.4832 27.1906C29.5533 27.9549 29.5533 29.5454 28.4832 30.3098L23.9583 33.5418M23.9583 23.9585L25.875 22.0418'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M23.9175 14.9869L25.9779 13.1326C27.024 12.191 28.598 12.1453 29.6972 13.0245L32.5833 15.3335M23.9175 14.9869L29.325 18.5918L32.5833 15.3335M23.9175 14.9869L11.5 6.7085M32.5833 15.3335L33.5417 21.403L40.25 25.8752M23.9583 23.9585L21.288 22.1783C19.9964 21.3171 19.6625 19.6399 20.3755 18.3755M23.9583 23.9585L28.4832 27.1906C29.5533 27.9549 29.5533 29.5454 28.4832 30.3098L23.9583 33.5418M23.9583 23.9585L25.875 22.0418'
      stroke='url(#paint3_radial_5304_2392)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M5.75 23L32.5833 40.25L37.375 39.2917'
      stroke='url(#paint4_linear_5304_2392)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M5.75 23L32.5833 40.25L37.375 39.2917'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M5.75 23L32.5833 40.25L37.375 39.2917'
      stroke='url(#paint5_radial_5304_2392)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5304_2392'
        x1='32.5833'
        y1='5.75'
        x2='39.1551'
        y2='10.3112'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5304_2392'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(35.4566 11.5) scale(2.87337 2.92811)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5304_2392'
        x1='11.5'
        y1='6.7085'
        x2='42.8562'
        y2='30.039'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5304_2392'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(25.875 33.5418) scale(14.375 13.6645)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_5304_2392'
        x1='5.75'
        y1='23'
        x2='26.1959'
        y2='49.0307'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_5304_2392'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(21.5625 40.25) scale(15.8125 8.78434)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'AlpineSkiingIcon'
)

export default AlpineSkiingIcon
